/**
 * "Sort by" dropdown — the first section inside the filter sidebar / sheet.
 *
 * Extracted from `app/(main)/products/ProductsClient.tsx` lines 1335–1349.
 */

"use client";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FilterSection } from "./FilterSection";

export const VALID_SORTS = [
  "default",
  "priceAsc",
  "priceDesc",
  "newest",
  "bestselling",
  "onSale",
] as const;

export type ProductSort = (typeof VALID_SORTS)[number];

interface SortSectionProps {
  value: ProductSort;
  onChange: (v: ProductSort) => void;
  isOpen: boolean;
  onToggleSection: (title: string) => void;
}

export function SortSection({
  value,
  onChange,
  isOpen,
  onToggleSection,
}: SortSectionProps) {
  return (
    <FilterSection title="Sort by" isOpen={isOpen} onToggle={onToggleSection}>
      <Select
        value={value}
        onValueChange={(v) => {
          const next: ProductSort =
            (VALID_SORTS as readonly string[]).includes(v)
              ? (v as ProductSort)
              : "default";
          onChange(next);
        }}
      >
        <SelectTrigger className="w-full" aria-label="Sort products">
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        {/* popper (not item-aligned) so opening the dropdown doesn't scroll the
            sidebar's filter-scroll-container to align the selected item. */}
        <SelectContent position="popper">
          <SelectItem value="default">Featured</SelectItem>
          <SelectItem value="bestselling">Most Popular</SelectItem>
          <SelectItem value="priceAsc">Price: Low to High</SelectItem>
          <SelectItem value="priceDesc">Price: High to Low</SelectItem>
          <SelectItem value="newest">Newest</SelectItem>
          <SelectItem value="onSale">On Sale</SelectItem>
        </SelectContent>
      </Select>
    </FilterSection>
  );
}
